import React from "react";
import Card from "@components/cards/Card/Card";
import Button from "@components/buttons/Button/Button";
import styles from "@styles/CommonAuthPageLayout.module.css";

const ResetRequestConfirmationPage = () => {
    return (
        <div>
            <Card className={styles.cardContainer}>
                <div className={styles.linkContainer}>
                <p>Password reset requested! We&apos;ve sent you an email with instructions to reset your password. Please check your inbox and spam folder.</p>

                </div>
                <div className={styles.buttonLinkContainer}>
                    <Button
                        variant="primary"
                        to="/auth/sign-in"
                    >
                        Sign In
                    </Button>
                </div>
            </Card>
        </div>
    );
};

export default ResetRequestConfirmationPage;
